(function () {
  function initHub(root) {
    if (!root || root.dataset.scenarioContentHubInit === 'true') return;
    root.dataset.scenarioContentHubInit = 'true';

    const groups = Array.from(root.querySelectorAll('[data-content-group]'));
    const modal = root.querySelector('[data-inspiration-modal]');
    let activeScenario = '';
    let activeVariantId = '';
    let cartSubmitting = false;

    function itemsFor(group) {
      return Array.from(group.querySelectorAll('[data-content-item]'));
    }

    function updateGroup(group) {
      const items = itemsFor(group);
      const visibleItems = items.filter(
        (item) => item.dataset.contentScenario === activeScenario
      );

      items.forEach((item) => {
        item.hidden = !visibleItems.includes(item);
      });
      group.hidden = visibleItems.length === 0;
    }

    function updateExploreLinks() {
      const exploreNav = root.querySelector('[data-scenario-explore]');
      if (!exploreNav) return;

      const shop = document.querySelector('[data-scenario-shop]');
      const singleScenario =
        shop && shop.getAttribute('data-single-scenario') === 'true';

      if (singleScenario) {
        exploreNav.hidden = true;
        return;
      }

      const buttons = Array.from(exploreNav.querySelectorAll('[data-explore-scenario]'));
      buttons.forEach((button) => {
        button.hidden = button.dataset.exploreScenario === activeScenario;
      });
      const visibleCount = buttons.filter((button) => !button.hidden).length;
      exploreNav.hidden = visibleCount === 0;
    }

    function updateContent(scenario) {
      activeScenario = scenario || activeScenario;
      if (!activeScenario) return;
      groups.forEach(updateGroup);
      updateExploreLinks();
    }

    function trackSlug(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function clearStoryAtcClass(addButton) {
      if (!addButton) return;
      Array.prototype.slice.call(addButton.classList).forEach(function (cls) {
        if (/^scenario-.+-story-\d+-atc$/.test(cls)) addButton.classList.remove(cls);
      });
    }

    function syncStoryAtcClass(card, addButton) {
      clearStoryAtcClass(addButton);
      if (!card || !addButton) return;
      var base = (card.getAttribute('data-scenario-story') || '').trim();
      if (/^scenario-.+-story-\d+$/.test(base)) {
        addButton.classList.add(base + '-atc');
      }
    }

    // 灵感卡点击：scenario-{moment}-story-clickN；弹窗 ATC 仍用 data-scenario-story → …-story-N-atc
    function syncStoryTrackClasses(momentKey) {
      var inspGroup = root.querySelector('[data-content-group="inspiration"]');
      if (!inspGroup) return;
      var key = trackSlug(momentKey) || trackSlug(activeScenario);
      if (!key) return;
      var cards = Array.from(inspGroup.querySelectorAll('[data-inspiration-card]')).filter(
        function (card) {
          return card.dataset.contentScenario === activeScenario;
        }
      );
      cards.forEach(function (card, index) {
        Array.prototype.slice.call(card.classList).forEach(function (cls) {
          if (/^scenario-.+-story-click\d+$/.test(cls)) card.classList.remove(cls);
          if (/^scenario-.+-story-\d+$/.test(cls)) card.classList.remove(cls);
        });
        var n = index + 1;
        var clickCls = 'scenario-' + key + '-story-click' + n;
        var atcBase = 'scenario-' + key + '-story-' + n;
        card.classList.add(clickCls);
        card.setAttribute('data-scenario-story', atcBase);
        card.setAttribute('data-story-index', String(n));
      });
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('scenario-inspiration-modal-open');
      activeVariantId = '';
      clearStoryAtcClass(modal.querySelector('[data-modal-add]'));
    }

    function openModal(card) {
      if (!modal || !card) return;
      const imageWrap = modal.querySelector('[data-modal-image-wrap]');
      const title = modal.querySelector('[data-modal-title]');
      const description = modal.querySelector('[data-modal-description]');
      const productWrap = modal.querySelector('[data-modal-product]');
      const productName = modal.querySelector('[data-modal-product-name]');
      const productPrice = modal.querySelector('[data-modal-product-price]');
      const addButton = modal.querySelector('[data-modal-add]');
      const imageUrl = card.dataset.modalImage;
      const variantId = (card.dataset.modalVariantId || '').trim();
      const price = (card.dataset.modalPrice || '').trim();
      const productLabel = (card.dataset.modalProduct || '').trim();
      const productUrl = (card.dataset.modalUrl || '').trim();

      imageWrap.innerHTML = '';
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = card.dataset.modalTitle || '';
        imageWrap.appendChild(image);
      }

      title.textContent = card.dataset.modalTitle || '';
      description.textContent = card.dataset.modalDescription || '';
      productName.textContent = productLabel || '';
      if (productPrice) {
        productPrice.textContent = price;
        productPrice.hidden = !price;
      }

      activeVariantId = variantId;
      if (addButton) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
        addButton.dataset.fallbackUrl = productUrl && productUrl !== '/' ? productUrl : '';
      }
      syncStoryAtcClass(card, addButton);

      const showCta = Boolean(productLabel || variantId);
      productWrap.hidden = !showCta;
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('scenario-inspiration-modal-open');
      const closeButton = modal.querySelector('[data-inspiration-close]');
      if (closeButton) closeButton.focus();
    }

    function addSameKit(button) {
      if (cartSubmitting) return;

      if (!activeVariantId) {
        const fallback = button && button.dataset.fallbackUrl;
        if (fallback) {
          window.location.href = fallback;
          return;
        }
        window.alert('Please bind a product on this inspiration card in the theme editor.');
        return;
      }

      if (!window.ScenarioCart || typeof window.ScenarioCart.addToCart !== 'function') {
        return;
      }

      cartSubmitting = true;
      window.ScenarioCart.addToCart({
        variantId: activeVariantId,
        button: button,
        source: 'scenario-content-hub'
      })
        .then(() => {
          closeModal();
        })
        .catch(() => {})
        .finally(() => {
          cartSubmitting = false;
        });
    }

    root.addEventListener('click', (event) => {
      const inspirationCard = event.target.closest('[data-inspiration-card]');
      if (inspirationCard) {
        openModal(inspirationCard);
        return;
      }

      if (event.target.closest('[data-inspiration-close]')) {
        closeModal();
        return;
      }

      const addButton = event.target.closest('[data-modal-add]');
      if (addButton && modal && !modal.hidden) {
        event.preventDefault();
        addSameKit(addButton);
        return;
      }

      const exploreButton = event.target.closest('[data-explore-scenario]');
      if (!exploreButton) return;

      const key = exploreButton.dataset.exploreScenario;
      document.dispatchEvent(
        new CustomEvent('scenario:activate', {
          bubbles: true,
          detail: { scenario: key }
        })
      );
      const target = document.getElementById('scenario-shop');
      if (!target) return;
      const header = document.querySelector('sticky-header, header');
      const offset = header ? header.getBoundingClientRect().height : 0;
      window.scrollTo({
        top: window.scrollY + target.getBoundingClientRect().top - offset,
        behavior: 'smooth'
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
    });

    document.addEventListener('scenario:change', (event) => {
      const detail = event.detail || {};
      updateContent(detail.scenario);
      syncStoryTrackClasses(detail.effectiveMoment || detail.defaultMoment || '');
    });

    document.addEventListener('scenario:moment-change', (event) => {
      const detail = event.detail || {};
      if (detail.scenario) updateContent(detail.scenario);
      syncStoryTrackClasses(detail.moment || '');
    });

    const activeTab = document.querySelector('[data-scenario-tab].is-active');
    if (activeTab) updateContent(activeTab.dataset.scenarioTab);
    else updateExploreLinks();

    var activeMomentBtn = document.querySelector('[data-scenario-moment].is-active');
    var initialMoment = activeMomentBtn
      ? activeMomentBtn.getAttribute('data-moment-key') || ''
      : '';
    syncStoryTrackClasses(initialMoment);
  }

  function initAll() {
    document
      .querySelectorAll('[data-scenario-content-hub]')
      .forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.querySelector('[data-scenario-content-hub]') ||
      event.target.closest('[data-scenario-content-hub]');
    if (root) {
      root.dataset.scenarioContentHubInit = 'false';
      initHub(root);
    }
  });
})();
